var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-button-wrap"},[_c('button',{class:`save-btn ${_vm.btnClass}`},[_c('span',[_vm._v("save and next")]),_c('img',{attrs:{"src":require("@/assets/save.svg"),"alt":"save"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }